module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scenario_info"
  }, [(_vm.campaignId && _vm.campaignId !== '0') ? _c('span', [_vm._v("Campaign ID: " + _vm._s(_vm.campaignId))]) : _vm._e(), _vm._v(" "), (_vm.scenarioId) ? _c('span', [_vm._v("Scenario ID: " + _vm._s(_vm.scenarioId))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-536189e6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/ScenarioInfo.vue
// module id = 485
// module chunks = 42